export function normalizeUpdaterTenantKey(tenantKey) {
	return String(tenantKey || '').trim().toLowerCase();
}

export function normalizeUpdaterFeedUrl(raw) {
	return String(raw || '').trim().replace(/\/+$/, '');
}

export function deriveUpdaterFeedUrlTemplateFromManifest(raw) {
	const normalized = normalizeUpdaterFeedUrl(raw);
	if (!normalized) {
		return '';
	}
	const derived = normalized.replace(
		/\/(?:\{tenantKey\}|%7BtenantKey%7D)\/manifest-latest\.json$/i,
		'/desktop-updater/tenants/{tenantKey}'
	);
	return derived === normalized ? '' : derived;
}

export function resolveUpdaterFeedUrlTemplate(options = {}) {
	const explicit = normalizeUpdaterFeedUrl(options.explicitTemplate || '');
	if (explicit) {
		return explicit;
	}
	const derived = deriveUpdaterFeedUrlTemplateFromManifest(options.manifestTemplate || '');
	if (derived) {
		return derived;
	}
	return normalizeUpdaterFeedUrl(options.defaultTemplate || '');
}

export function buildUpdaterFeedUrl(tenantKey, options = {}) {
	const normalizedTenantKey = normalizeUpdaterTenantKey(tenantKey);
	if (!normalizedTenantKey) {
		throw new Error('租户号未准备好，无法配置应用更新源');
	}
	const directFeedUrl = normalizeUpdaterFeedUrl(options.explicitFeedUrl || '');
	if (directFeedUrl) {
		return directFeedUrl;
	}
	const template = normalizeUpdaterFeedUrl(options.feedUrlTemplate || '');
	if (!template) {
		throw new Error('应用更新源未配置，请联系管理员');
	}
	if (template.includes('{tenantKey}')) {
		return template.replace(/\{tenantKey\}/g, encodeURIComponent(normalizedTenantKey));
	}
	return `${template}/${encodeURIComponent(normalizedTenantKey)}`;
}
